module.exports = __webpack_public_path__ + "img/能力体系.cc56793b.svg";